import { render, staticRenderFns } from "./b-numero.vue?vue&type=template&id=4d1ea347&scoped=true"
import script from "./b-numero.vue?vue&type=script&lang=js"
export * from "./b-numero.vue?vue&type=script&lang=js"
import style0 from "./b-numero.vue?vue&type=style&index=0&id=4d1ea347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ea347",
  null
  
)

export default component.exports